import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useReviewModalStyles = makeStyles((theme) =>
  createStyles({
    root: {
      [theme.breakpoints.down('xs')]: {
        width: '100%',
        height: '100%'
      },

      '& .MuiDialog-paperScrollPaper': {
        display: 'flex',
        flexDirection: 'column',
        height: 611,
        width: 875,
        borderRadius: 10,

        [theme.breakpoints.down('xs')]: {
          borderRadius: 0,
          width: '100%',
          height: 600,
          maxHeight: '80%',
          margin: 0
        }
      },

      '&. MuiBackdrop': {
        background: 'red'
      }
    },

    modalHeader: {
      padding: '20px 28px 14px 30px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: '0px -2px 22px rgba(0, 0, 0, 0.25)',

      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        padding: '20px 23px 9px 16px',
        boxShadow: 'none',
        alignItems: 'normal',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
      }
    },

    modalHeaderTop: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 15
    },

    modalTitle: {
      fontSize: 20,
      fontWeight: 600,
      lineHeight: '23px'
    },

    modalHeaderRight: {
      display: 'flex',
      gap: 40
    },

    tabs: {
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      },

      '& .MuiTabs-flexContainer': {
        gap: 20,

        [theme.breakpoints.down('xs')]: {
          gap: 0,
          justifyContent: 'space-between'
        }
      }
    },

    tab: {
      padding: 0,
      minWidth: 85,
      borderRadius: '5px',
      transition: '0.3s',

      '&:hover': {
        background: '#f6f6f6'
      },

      [theme.breakpoints.down('xs')]: {
        fontSize: 12
      }
    },

    closeButton: {
      padding: 0
    },

    closeIcon: {
      width: 28,
      height: 28,

      [theme.breakpoints.down('xs')]: {
        width: 20,
        height: 20
      }
    },

    tabPanels: {
      [theme.breakpoints.up('sm')]: {
        flex: 1
      },
      [theme.breakpoints.down('xs')]: {
        height: '66%'
      }
    },

    tabPanel: {
      flex: 1,
      padding: '12px 16px 0 32px',
      maxHeight: 457,
      overflowY: 'auto',
      scrollbarColor: '#9E9E9E #EAEAEA',
      scrollbarWidth: 'thin',
      '&::-webkit-scrollbar': {
        width: 7,
        backgroundColor: '#EAEAEA'
      },
      '&::-webkit-scrollbar-track': {
        borderRadius: 10
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#9E9E9E',
        borderRadius: 10,
        backgroundClip: 'padding-box'
      },

      [theme.breakpoints.down('xs')]: {
        maxHeight: '100%',
        height: '100%'
      }
    },

    modalBottom: {
      flex: 1,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 47px 0 32px',
      boxShadow: '0px -2px 22px rgba(0, 0, 0, 0.25)',
      maxHeight: 88,

      [theme.breakpoints.down('xs')]: {
        padding: '0 24px 0 14px',
        boxShadow: 'none',
        borderTop: '1px solid rgba(0, 0, 0, 0.12)'
      }
    },

    backBtn: {
      textTransform: 'none',
      color: '#9E9E9E'
    },

    leaveReviewBtn: {
      padding: '9px 18px',
      fontSize: 12
    }
  })
)
